export function useChat() {
	const config = useNuxtApp().$config.public;
	const isTest = useIsTest();

	const disableChat = computed(() => {
		const isDisabledByConfig = config.disableChat;

		return Boolean(isDisabledByConfig);
	});

	if (!disableChat.value) {
		useScript({
			src: isTest ? "https://chat-client.web.test.apc.telenor.net/client.js" : "https://chat.telenor.no/client.js",
			crossorigin: false,
			referrerpolicy: false,
		});
	}

	return { disableChat };
}
